/* Bildergalerie der Produktseite. Dawn-Stil: ein Custom Element, kein Framework.
   Aufgabe: Klick auf ein Vorschaubild tauscht das große Bild.
   Ohne JavaScript bleiben Hauptbild und Vorschaubilder als reine Anzeige stehen. */
if (!customElements.get('mus-gallery')) {
  customElements.define('mus-gallery', class MusGallery extends HTMLElement {
    connectedCallback() {
      this.mainImage = this.querySelector('.mus-pdp__gallery-main img');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
      if (!this.mainImage || !this.thumbs.length) return;

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb || !this.contains(thumb)) return;
      this.show(thumb);
    }

    show(thumb) {
      const image = this.mainImage;
      if (thumb.dataset.srcset) image.srcset = thumb.dataset.srcset;
      if (thumb.dataset.src) image.src = thumb.dataset.src;
      if (thumb.dataset.width) image.width = Number(thumb.dataset.width);
      if (thumb.dataset.height) image.height = Number(thumb.dataset.height);
      image.alt = thumb.dataset.alt || '';

      this.thumbs.forEach((element) => {
        if (element === thumb) {
          element.setAttribute('aria-current', 'true');
        } else {
          element.removeAttribute('aria-current');
        }
      });
    }
  });
}
